import Stack from "@mui/material/Stack";
import { isDefinedArray } from "et3-type-guards";
import { EmptyState } from "et3-ui-library/mui";
import i18n from "../../../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import getKhattabat101MGeneralStore from "../../../../../stores/khattabat-stores/101m-stores/general-101m-store";
import getKhattabatFilterStore from "../../../../../stores/khattabat-stores/filter-store";
import KhattabatMatchConversation from "./KhattabatMatchConversation";

const KhattabatMatchConversations = withLiteObserverAndTheme(() => {
  const matchIDs = getKhattabat101MGeneralStore().orderedMatchIDs.get();
  const isSearching = getKhattabatFilterStore().isSearching1o1MMatches.get();

  if (!isDefinedArray(matchIDs)) {
    return (
      <EmptyState
        title={i18n.get(
          isSearching
            ? "KHATTABAT_101M_NO_FILTER_RESULTS"
            : "KHATTABAT_101M_EMPTY"
        )}
      />
    );
  }

  return (
    <Stack spacing={1}>
      {matchIDs.map((matchID) => (
        <KhattabatMatchConversation key={matchID} matchID={matchID} />
      ))}
    </Stack>
  );
});

export default KhattabatMatchConversations;
